import AddButton from "../Buttons/AddButton";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { addFilter, editFilter,addParentFilter,editParentFilter } from "../../features/filtersSlice";
import CloseButton from "../Buttons/CloseButton";
import {
  Label,
  FormWrapper,
  StyledInput,
  InputWrapper,
  ButtonWrapper,
} from "./Form";
import { useTranslation } from "react-i18next";

export default function FilterForm({ onClick, parentId, id, initialData,onClose,filter ,indexNo}) {
  const [name, setName] = useState(initialData.name);
  const [tag, setTag] = useState(initialData.tag);
  const [nameChanged, setNameChanged] = useState(false);
  const [tagChanged, setTagChanged] = useState(false);
  const [parentName, setParentName] = useState(initialData.name);
  const [parentTag, setParentTag] = useState(initialData.tag);

  const { t } = useTranslation();

  const dispatch = useDispatch();
  useEffect(() => {
    setName(initialData.name);
    setTag(initialData.tag)
  }, [initialData])

  function handleSubmit(e) {
    e.preventDefault();
  if(filter==="fromChild"){
    const payload = {
      id: indexNo+1,
      child: {
        id: id,
        key: name,
        value: tag,
      },
    };
    dispatch(
      initialData.name !== "" ? editFilter(payload) : addFilter(payload),
    );
    onClick();
  }else{
    const payload = {
      id: initialData.name !== "" ?indexNo: parentId,
      key:parentName,
      value:parentTag,
      child_parameters:[]

    };
    dispatch(
      initialData.name !== "" ? editParentFilter(payload) : addParentFilter(payload),

    );
    onClose()
  }
    
  }

  return (
    <FormWrapper onSubmit={handleSubmit}>
    {filter==="fromChild" && <CloseButton handleClose={onClick} />}
     {filter==="fromParent" && <CloseButton handleClose={onClose} />}
     {filter==="fromChild" && <> <InputWrapper>
        <Label>{t("filterPage.FilterName")}</Label>
        <StyledInput
          placeholder={t("common.ClickToAdd")}
          value={name}
          required
          onChange={(e) => {
            setName(e.target.value);
            setNameChanged(initialData.name != e.target.value);
          }}
        />
      </InputWrapper>
      <InputWrapper>
        <Label>{t("filterPage.RoutingTag")}</Label>
        <StyledInput
          placeholder={t("common.ClickToAdd")}
          value={tag}
          required
          onChange={(e) => {
            setTag(e.target.value);
            setTagChanged(initialData.name != e.target.value);
          }}
        />
      </InputWrapper></>}
      {filter==="fromParent" && <> <InputWrapper>
        <Label>{t("filterPage.ParentFilterName")}</Label>
        <StyledInput
          placeholder={t("common.ClickToAdd")}
          value={parentName}
          required
          onChange={(e) => {
            setParentName(e.target.value);
            setTagChanged(initialData.name != e.target.value);

          }}
        />
      </InputWrapper>
      <InputWrapper>
        <Label>{t("filterPage.RoutingTag")}</Label>
        <StyledInput
          placeholder={t("common.ClickToAdd")}
          value={parentTag}
          required
          onChange={(e) => {
            setParentTag(e.target.value);
            setTagChanged(initialData.name != e.target.value);

          }}
        />
      </InputWrapper></>}
      <ButtonWrapper>
      {filter==="fromChild" &&  <AddButton editMode={initialData.name && initialData.tag} disabled={!(nameChanged || tagChanged)}/>}
        {filter==="fromParent" && <AddButton editMode={initialData.name && initialData.tag} disabled={!(nameChanged || tagChanged)}/>}

      </ButtonWrapper>
    </FormWrapper>
  );
}
